export const truncateAssetName = (name, maxLength = 10) => {
  if (!name || name.length <= maxLength) {
    return name;
  }
  return name.substring(0, maxLength) + '...';
};
